import { FAQSortColumn, IFAQFilters } from '../types/manageFAQ';
import { SORTING_DIRECTION } from '~/constants/main';

export const defaultFAQFilters: IFAQFilters = {
  search: '',
  status: undefined,
  sortField: FAQSortColumn.NO,
  sortDir: SORTING_DIRECTION.ASCENDING,
};
